/**
 * Amplitude helpers for Monthly Gifts analytics
 * Keeps event names + property shapes in one place
 */
import { logEvent } from './analytics';

function log(event, properties = {}) {
    logEvent(event, properties);
}

/** Public registry or plan page — monthly CTA card became visible. */
export function logMonthlyCardViewed({ source, plan_id, account_name, is_gg_plus, is_premium } = {}) {
    const ggPlus = is_gg_plus != null ? is_gg_plus : is_premium;
    log('monthly card viewed', {
        source,
        ...(plan_id != null ? { plan_id } : {}),
        ...(account_name ? { account_name } : {}),
        ...(ggPlus != null ? { is_gg_plus: !!ggPlus } : {}),
    });
}

/** User clicked a monthly deep link (registry CTA — navigates into the flow). */
export function logMonthlyLinkClicked({ source, variant, plan_id } = {}) {
    log('monthly link clicked', {
        source,
        ...(variant ? { variant } : {}),
        ...(plan_id != null ? { plan_id } : {}),
    });
}

/** User entered the reordered monthly gift flow (frequency=monthly deep link). */
export function logMonthlyFlowStarted({ source, account_id, guest } = {}) {
    log('monthly flow started', {
        source: source || 'monthly link',
        ...(account_id != null ? { account_id } : {}),
        ...(guest != null ? { guest: !!guest } : {}),
    });
}

/** User completed a step in the monthly gift flow. */
export function logMonthlyFlowStepCompleted(step, stepName, extra = {}) {
    log('monthly flow step completed', {
        step,
        step_name: stepName,
        ...extra,
    });
}

/** User tapped Start Monthly Gift / confirm on pay step — setup API call begins. */
export function logMonthlySetupStarted({ gift_amount, duration_months, guest, pm_type, account_id } = {}) {
    log('monthly setup started', {
        gift_amount,
        duration_months,
        ...(guest != null ? { guest: !!guest } : {}),
        ...(pm_type ? { pm_type } : {}),
        ...(account_id != null ? { account_id } : {}),
    });
}

/** Plan finalized successfully — first gift created. */
export function logMonthlySetupCompleted({ gift_amount, duration_months, guest, pm_type, match_applied, account_id } = {}) {
    log('monthly setup completed', {
        gift_amount,
        duration_months,
        ...(guest != null ? { guest: !!guest } : {}),
        ...(pm_type ? { pm_type } : {}),
        ...(match_applied != null ? { match_applied: !!match_applied } : {}),
        ...(account_id != null ? { account_id } : {}),
    });
}

/** Success overlay shown after monthly checkout. */
export function logMonthlySuccessViewed({ gift_amount, duration_months, next_gift_date } = {}) {
    log('monthly success viewed', {
        ...(gift_amount ? { gift_amount } : {}),
        ...(duration_months != null ? { duration_months } : {}),
        ...(next_gift_date ? { next_gift_date } : {}),
    });
}

export function logMonthlyInviteModalOpened({ plan_id } = {}) {
    log('monthly invite modal opened', { plan_id, source: 'plan_page' });
}

export function logMonthlyInviteEmailSent({ plan_id } = {}) {
    log('monthly invite email sent', { plan_id, source: 'plan_page' });
}

export function logMonthlyInviteCopyLink({ source, plan_id } = {}) {
    log('monthly invite copy link', { source, ...(plan_id != null ? { plan_id } : {}) });
}

/** Guest manage page loaded with a valid token. */
export function logMonthlyManagePageViewed({ plan_id, status } = {}) {
    log('monthly manage page viewed', {
        source: 'manage_token',
        ...(plan_id != null ? { plan_id } : {}),
        ...(status ? { status } : {}),
    });
}

/** User confirmed cancel on the manage page. */
export function logMonthlyPlanCanceled({ plan_id, months_completed, total_months } = {}) {
    log('monthly plan canceled', {
        source: 'manage_token',
        ...(plan_id != null ? { plan_id } : {}),
        ...(months_completed != null ? { months_completed } : {}),
        ...(total_months != null ? { total_months } : {}),
    });
}
